import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    level: {
      type: Number,
      default: 0
    }
  },
  computed: {
    imgSrc: function imgSrc() {
      return ['//puep.qpic.cn/vupload/0/20190115_1547623719607_yan7qifxfuh.png/0', '//puep.qpic.cn/vupload/0/20190115_1547623719607_8bm8giwg6r5.png/0', '//puep.qpic.cn/vupload/0/20190115_1547623719608_07hyx3g6rmhb.png/0', '//puep.qpic.cn/vupload/0/20190115_1547623719608_ljry3o3nn8.png/0', '//puep.qpic.cn/vupload/0/20190115_1547623719608_vyjv390lpf.png/0', '//puep.qpic.cn/vupload/0/20190115_1547623719609_wencg0wb04f.png/0', '//puep.qpic.cn/vupload/0/20190115_1547623719609_imsalw9f5z.png/0'][this.level - 1];
    }
  }
};